import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
// import BillPrint from '../sale/Bill';
import PrintIcon from '@mui/icons-material/Print';
import Info from '@mui/icons-material/Info';
import ReactDOM from 'react-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import '../../../stylesheet.css';
import { Tooltip } from '@mui/material';

function StockJournalIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');
    const branchId = 0;

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data        
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const fetchTableData = async () => {
        setData([]);
        try {
            const response = await fetchData('StockJournalApi', `/CustomerDetails/${companyId}/${branchId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }
    };

    const handleDelete = async () => {
        deleteData('SaleApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchTableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('SaleApi', `${itemId}`, token)
            .then(() => {
                fetchTableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    return (
        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '5px' }}>

            <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>STOCK JOURNAL </h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '300px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '25px'
                        }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block tracking-wide text-black text-xs mb-2" htmlFor="gstNumber">
                        From
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block tracking-wide text-black text-xs mb-2" htmlFor="gstNumber">
                        To
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ fontSize: '12.5px', marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <Tooltip title="Get Stock Journal Details" arrow>
                    <Button
                        style={{
                            backgroundColor: '#1090a3ff', color: 'white', height: '26px', marginRight: '8px',
                            marginLeft: '5px', marginTop: '25px'
                        }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <span style={{ fontSize: '13px' }}>Refresh</span>
                    </Button>
                </Tooltip>

                {hasCreateMasterPermission && (
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                        <Tooltip title="Create New Stock Journal" arrow>
                            <Button
                                component={Link}
                                to="/StockJournalCreate"
                                className="linkcolor"
                                style={{
                                    backgroundColor: '#3F4F44', color: 'white', height: '26px', marginRight: '8px',
                                    marginLeft: '5px', marginTop: '-7px'
                                }}
                            >
                                <span style={{ fontSize: '13px' }}>Create</span>
                            </Button>
                        </Tooltip>
                    </div>
                )}

            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', marginTop: '-7px' }}>
                <TableContainer component={Paper}>
                    <Table>
                        {/* <TableHead sx={{ backgroundColor: '#58A5B3' }}> */}
                        <TableHead sx={{ backgroundColor: 'white' }}>
                            <TableRow>
                                <TableCell className='table-header-cell'>Bill Date</TableCell>
                                <TableCell className='table-header-cell'>Bill Number</TableCell>
                                <TableCell className='table-header-cell'>Remark</TableCell>
                                <TableCell className='table-header-cell' style={{ padding: '3px', trextAlign: 'right' }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData.map((row) => (
                                <TableRow key={row.Id}>
                                    <TableCell className='table-header-cell.child' style={{ padding: '3px' }}>{formatDate(row.BillDate)}</TableCell>
                                    <TableCell className='table-header-cell.child' style={{ padding: '3px' }}>{row.BillNumber}/{row.FinYear}</TableCell>
                                    <TableCell className='table-header-cell.child' style={{ padding: '3px' }}>{row.Remarks}</TableCell>
                                    <TableCell
                                        align="right" // ✅ easiest way
                                        style={{ padding: '3px' }}
                                    >
                                        <Tooltip title="Stock Journal Details" arrow>
                                            <IconButton
                                                component={Link}
                                                to={`/StockJournalDetails/${row.Id}`}
                                                aria-label="info"
                                            >
                                                <Info style={{ color: 'orange', fontSize: '19px' }} />
                                            </IconButton>
                                        </Tooltip>

                                        {hasEditMasterPermission && (
                                            <Tooltip title="Stock Journal Edit" arrow>
                                                <IconButton
                                                    component={Link}
                                                    to={`/StockJournalEdit/${row.Id}`}
                                                    aria-label="edit"
                                                >
                                                    <EditIcon style={{ color: 'green', fontSize: '19px' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}

                                        {hasDeleteMasterPermission && (
                                            <>
                                                {row.IsActive ? (
                                                    <Tooltip title="Stock Journal Delete" arrow>
                                                        <IconButton
                                                            onClick={() => openConfirmDialog(row.Id)}
                                                            aria-label="delete"
                                                        >
                                                            <DeleteIcon style={{ color: 'red', fontSize: '19px' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title="Stock Journal Activate" arrow>
                                                        <IconButton
                                                            onClick={() => handleActivate(row.Id)}
                                                            aria-label="activate"
                                                        >
                                                            <ActivateIcon style={{ color: 'green', fontSize: '19px' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </>
                                        )}
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            <Dialog open={confirmDialogOpen} onClose={closeConfirmDialog}>
                <DialogTitle>Delete Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeConfirmDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default StockJournalIndex;
